#import "./TrainingCourseAdminFields.graphql"

query GetTrainingCourse($id: ID!) {
  trainingCourse(id: $id) {
    ...TrainingCourseAdminFields
  }
}
